import { render, staticRenderFns } from "./projectGoodsList.vue?vue&type=template&id=386abca4&scoped=true&"
import script from "./projectGoodsList.vue?vue&type=script&lang=js&"
export * from "./projectGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./projectGoodsList.vue?vue&type=style&index=0&id=386abca4&lang=less&scoped=true&"
import style1 from "./projectGoodsList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386abca4",
  null
  
)

component.options.__file = "projectGoodsList.vue"
export default component.exports